import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { ref } from 'vue'

import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { customerConversionTaskSave, customerConversionTaskUpdate } from '@/api/overseasSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { CustomerConversionTaskSaveParams } from '@/typings/api/overseasSales'
import { DcMessage } from '@dc-platform/dc-components'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'editModal' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<CustomerConversionTaskSaveParams>({})
const emit = __emit
const toggle = (row?: CustomerConversionTaskSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
    editForm.value.monthDate = dayjs(row.monthDate)
  } else {
    editForm.value = {}
  }
}

const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true

    try {
      if (editForm.value.id) {
        await customerConversionTaskUpdate({
          ...editForm.value,
          id: editForm.value.id,
          monthDate: dayjs(editForm.value.monthDate).format('YYYY/MM/DD 00:00:00'),
          appId: 'cos_ofbu'
        })
      } else {
        await customerConversionTaskSave({
          ...editForm.value,
          monthDate: dayjs(editForm.value.monthDate).format('YYYY/MM/DD 00:00:00'),
          appId: 'cos_ofbu'
        })
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? t('operate.mmet2b') : t('operate.ywoekr'))
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((visible).value = $event)),
    title: editForm.value.id ? _unref(t)('btn.edit') : _unref(t)('btn.add'),
    width: "600px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "manageAreaId",
                label: _unref(t)('operate.mzmxr7'),
                rules: [{ required: true, message: _unref(t)('common.pleaseSelect') }]
              }, {
                default: _withCtx(() => [
                  _createVNode(CustomerAreaCascader, {
                    appId: "cos_ofbu",
                    value: editForm.value.manageAreaId,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.manageAreaId) = $event)),
                    disabled: editForm.value.id
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }, 8, ["label", "rules"]),
              _createVNode(_component_a_form_item, {
                name: "seller",
                label: _unref(t)('operate.y20bdt'),
                rules: [{ required: true, message: _unref(t)('common.pleaseSelect') }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UserSelect, {
                    value: editForm.value.seller,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.seller) = $event)),
                    allowClear: "",
                    disabled: editForm.value.id
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }, 8, ["label", "rules"]),
              _createVNode(_component_a_form_item, {
                name: "clueNum",
                label: _unref(t)('operate.rn82s1')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.value.clueNum,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.clueNum) = $event)),
                    min: 0,
                    precision: 0,
                    max: 999999,
                    placeholder: _unref(t)('common.pleaseInput')
                  }, null, 8, ["value", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, {
                name: "customerContractNum",
                label: _unref(t)('operate.px4c2i')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.value.customerContractNum,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((editForm.value.customerContractNum) = $event)),
                    precision: 0,
                    min: 0,
                    max: 999999,
                    placeholder: _unref(t)('common.pleaseInput')
                  }, null, 8, ["value", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, {
                name: "customerDealNum",
                label: _unref(t)('operate.pphnkg')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.value.customerDealNum,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((editForm.value.customerDealNum) = $event)),
                    precision: 0,
                    min: 0,
                    max: 999999,
                    placeholder: _unref(t)('common.pleaseInput')
                  }, null, 8, ["value", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, {
                name: "customerPotentialNum",
                label: _unref(t)('operate.4n7op9')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: editForm.value.customerPotentialNum,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((editForm.value.customerPotentialNum) = $event)),
                    precision: 0,
                    min: 0,
                    max: 999999,
                    placeholder: _unref(t)('common.pleaseInput')
                  }, null, 8, ["value", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, {
                name: "monthDate",
                label: _unref(t)('operate.tnp6po'),
                rules: [{ required: true, message: _unref(t)('common.pleaseSelect') }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_date_picker, {
                    value: editForm.value.monthDate,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((editForm.value.monthDate) = $event)),
                    picker: "month"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label", "rules"])
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})